import Schedule from "./Schedule";

export default class Playlist {
  ID: number;
  ACCID: number;
  NAME: string;
  COLOR: string;
  contentIds: string[];
  deviceIds: number[];
  groupIds: number[];
  schedules: Schedule[];

  constructor(
    ID: number,
    ACCID: number,
    NAME: string,
    COLOR: string,
    contentIds: string[],
    deviceIds: number[],
    groupIds: number[],
    schedules?: Schedule[]
  ) {
    this.ID = ID;
    this.ACCID = ACCID;
    this.NAME = NAME;
    this.COLOR = COLOR;
    this.contentIds = contentIds;
    this.deviceIds = deviceIds;
    this.groupIds = groupIds;
    this.schedules = schedules || [];
  }

  clone() {
    return new Playlist(
      this.ID,
      this.ACCID,
      this.NAME,
      this.COLOR,
      this.contentIds,
      this.deviceIds,
      this.groupIds
    );
  }

  static fromObject(obj: {
    ID: number;
    ACCID: number;
    NAME: string;
    COLOR: string;
    contentIds: string[];
    deviceIds: number[];
    groupIds: number[];
  }) {
    return new Playlist(
      obj.ID,
      obj.ACCID,
      obj.NAME,
      obj.COLOR,
      obj.contentIds,
      obj.deviceIds,
      obj.groupIds
    );
  }
}
